import React from 'react';
import { Route } from 'react-router-dom';

// Client Pages
import Home from '../../pages/client/Home';
import Appointment from '../../pages/client/Appointment';
import ImmigrationExam from '../../pages/client/ImmigrationExam';

const ClientRoutes = [
  <Route key="home" path="/" element={<Home />} />,
  <Route key="appointment" path="/appointment" element={<Appointment />} />,
  <Route
    key="immigration-exam"
    path="/immigration-medical-exam-odessa-tx"
    element={<ImmigrationExam />}
  />
];

export default ClientRoutes;